// Toast wrapper around react-toastify matching mobile API
import { toast as reactToastify } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const showToast = (message, description = '', type = 'default', options = {}) => {
  const content = description ? (
    <div>
      <strong>{message}</strong>
      <div style={{ fontSize: '0.9em', marginTop: '4px' }}>{description}</div>
    </div>
  ) : (
    message
  );

  const toastOptions = {
    position: options.position || 'bottom-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  };

  switch (type) {
    case 'success':
      reactToastify.success(content, toastOptions);
      break;
    case 'error':
      reactToastify.error(content, toastOptions);
      break;
    case 'warning':
      reactToastify.warning(content, toastOptions);
      break;
    case 'info':
      reactToastify.info(content, toastOptions);
      break;
    default:
      reactToastify(content, toastOptions);
  }
};

export const showInternetToast = () => {
  showToast('Network Error', 'Please check your internet connection', 'error');
};

